import axios, {AxiosResponse} from 'axios'
import React, {useEffect, useState, Fragment } from 'react';
import {useIntl} from 'react-intl'
import {useParams, useHistory} from 'react-router-dom'
import {UserModel} from '../../auth/models/UserModel'
import {RootState} from '../../../../setup'
import {shallowEqual, useSelector} from 'react-redux'
import {FormBase} from '../../builderform/FormBase'
import {KTSVG} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {FormStepHorizontal} from '../../builderform/FormStepHorizontal'
import {UserCvModel} from '../models/UserCv'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'

const API_URL = process.env.REACT_APP_API_URL
//export const FORM_URL = `${API_URL}/services/entity/form`
export const GET_CV_URL = `${API_URL}/services/current/user/cv`
export const headers = {
    "Content-Type" : "application/hal+json",
    "Accept" : "application/hal+json"
}

export function GetUserCV(){
    const build_url = GET_CV_URL + '?_format=hal+json'
    return axios.get<UserCvModel>(build_url, {headers})
}
export function createBlankCv(title: string, id: number){
    const postheaders = {
        'Content-Type': 'application/json',
        'Accept' : 'application/json'
    }
    return axios.post(`${API_URL}/node?_format=json`, {'type': 'researcher','title': [title]}, {headers: postheaders})
}

export function FormProfile(){
    const intl = useIntl()
    const history = useHistory();
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [formStructure, setFormStructure] = useState<any>([]);
    const [formApprobationStructure, setFormApprobationStructure] = useState<any>([]);
    const { nid } = useParams<{ nid: string}>();
    
	const lang = useLang()
	const FORM_URL = API_URL + "/" + lang + "/services/entity/form"

    const build_url = typeof nid != "undefined" ? FORM_URL+ '?_format=hal+json&type=researcher&id='+ nid : FORM_URL+ '?_format=hal+json&type=researcher';

    useEffect(() => {
        // Use [] as second argument in useEffect for not rendering each time
        axios.get(build_url, {headers})
            .then((response: AxiosResponse) => {
                //STOCK GLOBAL
                window.FormSettings.researcher = response.data.settings;
                window.FormSettings.researcher.nosubmit = response.data.nosubmit
                console.log(Object.keys(response.data.structure), window.FormSettings.researcher)
                setFormStructure( Object.keys(response.data.structure) );
            });
        // APPROBATION FORM
        if(typeof nid != "undefined"){
            axios.get(build_url + "&display_mode=approbation_form", {headers})
                .then((response: AxiosResponse) => {
                    //STOCK GLOBAL
                    window.FormSettings.researcher_approbation = response.data.settings
                    window.FormSettings.researcher_approbation.nosubmit = response.data.nosubmit
                    setFormApprobationStructure( Object.keys(response.data.structure) )
                });
        }
    }, [build_url, nid]);

    if(formStructure.length > 1){
        return (
            <h1>
                ERROR in form display on the drupal instance
            </h1>
        )
    }
    return(
        <div>
            <a onClick={history.goBack} className='btn btn-sm btn-secondary me-3 mb-5'>
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-1 svg-icon-primary'
                />
                {intl.formatMessage({id: 'EDHEC.RETURN'})}
            </a>

            {typeof formStructure != "undefined" && formStructure.length > 0 ? (
                <FormStepHorizontal
                    items={formStructure[0]}
                    user={user.id}
                    nid={nid}
                    type='researcher'
                    destination='/'
                    form_name='researcher'
                />
            ):(
                <></>
            )}


            {typeof formApprobationStructure != "undefined" && formApprobationStructure.length > 0 ? (
                <FormBase
                    items={formApprobationStructure[0]}
                    user={user.id}
                    nid={nid}
                    type='researcher'
                    destination='/CV'
                    form_name='researcher_approbation'
                    title_form='Moderation'
                />
            ):(
                <></>
            )}
        </div>
    );
}
